import * as Sentry from '@sentry/vue';

export const sendExceptionToSentry = err => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentToken = urlParams.get('website_token');
  const disabledTokens = process.env.VUE_APP_SENTRY_DISABLED_WEBSITE_TOKENS.split(
    ','
  ).map(token => token.trim());
  if (currentToken && !disabledTokens.includes(currentToken)) {
    try {
      Sentry.captureException(err);
    } catch (err) {
      console.log('Sending error to sentry failed...', err);
    }
  }
};
